export default __webpack_public_path__ + "static/media/infoMarker.d777a73e.svg";